import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  RadioGroup,
  FormLabel,
  IconButton,
  Dialog,
  Radio,
  DialogTitle,
  FormControlLabel,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  Autocomplete
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Swal from 'sweetalert2';
import axios from 'axios';

const quizOptionsApiUrl = 'https://api.academy.eurekagroup.id/course-quiz-options';
const quizzesApiUrl = 'https://api.academy.eurekagroup.id/course-quizzes';

const QuizOptionPage = () => {
  const [quizOptions, setQuizOptions] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [idQuiz, setIdQuiz] = useState('');
  const [option, setOption] = useState('');
  const [optionText, setOptionText] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedQuiz, setSelectedQuiz] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetchQuizOptions();
    fetchQuizzes();
  }, []);

  const filteredQuizzes = quizzes.filter((quiz) =>
    quiz.question.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredQuizOptions = quizOptions.filter((option) => {
    const quiz = quizzes.find((q) => q._id === option.id_quiz);
    return (
      (!selectedCourse || quiz?.id_course?._id === selectedCourse) &&
      (!selectedQuiz || option.id_quiz === selectedQuiz)
    );
  });
  
  const fetchQuizOptions = async () => {
    try {
      const response = await axios.get(quizOptionsApiUrl);
      setQuizOptions(response.data);
    } catch (error) {
      console.error('Error fetching quiz options:', error);
    }
  };

  const fetchQuizzes = async () => {
    try {
      const response = await axios.get(quizzesApiUrl);
      setQuizzes(response.data);
    } catch (error) {
      console.error('Error fetching quizzes:', error);
    }
  };

  const handleSaveQuizOption = async () => {
    // Validasi awal
    if (!idQuiz || !option || !optionText) {
      Swal.fire({
        title: 'Error',
        text: 'Please fill in all required fields!',
        icon: 'error',
        confirmButtonText: 'OK',
        customClass: {
          popup: 'swal2-custom-zindex',
        },
      });
      return;
    }
  
    const quizOptionData = { id_quiz: idQuiz, option, option_text: optionText };
    const token = localStorage.getItem('token');
  
    try {
      if (selectedOption) {
        // Edit opsi quiz
        await axios.put(
          `${quizOptionsApiUrl}/edit`,
          { ...quizOptionData, id: selectedOption._id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setQuizOptions(
          quizOptions.map((qo) =>
            qo._id === selectedOption._id ? { ...qo, ...quizOptionData } : qo
          )
        );
      } else {
        // Periksa duplikasi berdasarkan id_quiz
        const isOptionDuplicate = quizOptions.some(
          (qo) =>
            qo.id_quiz === idQuiz &&
            (qo.option.toLowerCase() === option.toLowerCase() ||
              qo.option_text.toLowerCase() === optionText.toLowerCase())
        );
  
        if (isOptionDuplicate) {
          Swal.fire({
            title: 'Error',
            text: 'Opsi jawaban sudah ada!',
            icon: 'error',
            confirmButtonText: 'OK',
            customClass: {
              popup: 'swal2-custom-zindex',
            },
          });
          return;
        }
  
        // Tambah opsi quiz baru
        const response = await axios.post(`${quizOptionsApiUrl}/add`, quizOptionData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setQuizOptions([...quizOptions, response.data]);
        Swal.fire('Success', 'Quiz option added successfully', 'success');
      }
      closeDialog();
    } catch (error) {
      console.error('Error saving quiz option:', error.response?.data || error.message);
      Swal.fire('Error', 'Failed to save quiz option', 'error');
    }
  };
  
  
  // Menambahkan gaya global untuk swal2 z-index
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .swal2-container {
        z-index: 2100 !important; /* Lebih tinggi dari dialog MUI */
      }
    `;
    document.head.appendChild(style);
  
    // Bersihkan gaya saat komponen di-unmount
    return () => {
      document.head.removeChild(style);
    };
  }, []);  

  const handleDeleteQuizOption = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this quiz option!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
    });
  
    if (result.isConfirmed) {
      const token = localStorage.getItem('token'); // Ambil token dari localStorage
  
      try {
        await axios.delete(`${quizOptionsApiUrl}/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Menambahkan Bearer Token
          },
        });
        setQuizOptions(quizOptions.filter((qo) => qo._id !== id));
        Swal.fire('Deleted!', 'Quiz option has been deleted.', 'success');
      } catch (error) {
        console.error('Error deleting quiz option:', error);
        Swal.fire('Error', 'Failed to delete quiz option', 'error');
      }
    }
  };  

  const openDialog = (option) => {
    if (option) {
      setSelectedOption(option);
      setIdQuiz(option.id_quiz);
      setOption(option.option);
      setOptionText(option.option_text);
    } else {
      setSelectedOption(null);
      setIdQuiz('');
      setOption('');
      setOptionText('');
    }
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Card>
      <CardHeader
  title="Quiz Option Management"
  action={
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      {/* Filter Course */}
      <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
  <InputLabel>Filter by Course</InputLabel>
  <Select
    value={selectedCourse}
    onChange={(e) => setSelectedCourse(e.target.value)}
    label="Filter by Course"
  >
    <MenuItem value="">
      <em>All Courses</em>
    </MenuItem>
    {[...new Map(
      quizzes.map((quiz) => [quiz.id_course?._id, quiz.id_course])
    ).values()].map(
      (course) => (
        <MenuItem key={course?._id} value={course?._id}>
          {course?.title_course || 'Unknown Course'}
        </MenuItem>
      )
    )}
  </Select>
</FormControl>

      {/* Filter Quiz */}
      <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
        <InputLabel>Filter by Quiz</InputLabel>
        <Select
          value={selectedQuiz}
          onChange={(e) => setSelectedQuiz(e.target.value)}
          label="Filter by Quiz"
        >
          <MenuItem value="">
            <em>All Quizzes</em>
          </MenuItem>
          {quizzes.map((quiz) => (
            <MenuItem key={quiz._id} value={quiz._id}>
              {quiz.question}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Add Option Button */}
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => openDialog(null)}
      >
        Add Option
      </Button>
    </div>
  }
/>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>No</TableCell>
                  <TableCell>Quiz</TableCell>
                  <TableCell>Option</TableCell>
                  <TableCell>Option Text</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
  {filteredQuizOptions
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((option, index) => (
      <TableRow key={option._id}>
        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
        <TableCell>
          {quizzes.find((q) => q._id === option.id_quiz)?.question || 'N/A'}
        </TableCell>
        <TableCell>{option.option.toUpperCase()}</TableCell>
        <TableCell>{option.option_text}</TableCell>
        <TableCell>
          <IconButton onClick={() => openDialog(option)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => handleDeleteQuizOption(option._id)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ))}
</TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={quizOptions.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(0);
            }}
          />
        </CardContent>
      </Card>

      {/* Dialog */}
      <Dialog
  open={dialogOpen}
  onClose={() => {} /* Kosongkan fungsi ini agar tidak menutup saat klik luar */}
  disableBackdropClick // Ini mencegah dialog hilang saat klik di luar
>        
<DialogTitle>{selectedOption ? 'Edit Quiz Option' : 'Add Quiz Option'}</DialogTitle>
        <DialogContent>
        <FormControl fullWidth margin="dense" error={!idQuiz}>
  <Autocomplete
    value={idQuiz ? quizzes.find((quiz) => quiz._id === idQuiz) : null} // Tidak memilih otomatis
    onChange={(e, newValue) => {
      setIdQuiz(newValue?._id || ''); // Atur idQuiz sesuai pilihan pengguna
    }}
    options={quizzes}
    getOptionLabel={(quiz) => quiz.question}
    renderInput={(params) => <TextField {...params} label="Quiz" />}
    isOptionEqualToValue={(option, value) => option._id === value?._id} // Perbandingan antara option dan value
  />
  {!idQuiz && <FormHelperText>Quiz is required</FormHelperText>}
</FormControl>
<FormControl
  component="fieldset"
  fullWidth
  margin="dense"
  error={!option}
  style={{ marginTop: 16 }}
>
  <FormLabel
    component="legend"
    style={{
      fontWeight: 'bold',
      fontSize: '1rem',
      marginBottom: 8,
      color: '#555',
    }}
  >
    Select Option
  </FormLabel>
  <RadioGroup
    value={option}
    onChange={(e) => setOption(e.target.value)}
    style={{
      display: 'flex',
      flexDirection: 'row', // Align horizontally
      justifyContent: 'space-around', // Space between buttons
    }}
  >
    {['A', 'B', 'C', 'D'].map((opt) => (
      <FormControlLabel
        key={opt}
        value={opt}
        control={<Radio />}
        label={opt.toUpperCase()}
        style={{
          margin: '0 12px', // Spacing between radio buttons
          display: 'flex',
          alignItems: 'center',
        }}
      />
    ))}
  </RadioGroup>
  {!option && (
    <FormHelperText style={{ color: '#f44336', marginTop: 8 }}>
      Option is required
    </FormHelperText>
  )}
</FormControl>
          <TextField
            fullWidth
            margin="dense"
            label="Option Text"
            value={optionText}
            onChange={(e) => setOptionText(e.target.value)}
            error={!optionText}
            helperText={!optionText && 'Option Text is required'}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveQuizOption} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default QuizOptionPage;
